/**
 * @generated SignedSource<<50c79ec545d29db0232123c94440b22f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NodeInput = {
  id: string;
};
export type HighlightManageFormDeleteMutation$variables = {
  input: NodeInput;
};
export type HighlightManageFormDeleteMutation$data = {
  readonly deleteHighlight: {
    readonly highlightAlbum: {
      readonly coverImageUrl: string | null;
      readonly id: string;
    };
    readonly id: string;
  };
};
export type HighlightManageFormDeleteMutation = {
  response: HighlightManageFormDeleteMutation$data;
  variables: HighlightManageFormDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GraphQLHighlight",
    "kind": "LinkedField",
    "name": "deleteHighlight",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLHighlightAlbum",
        "kind": "LinkedField",
        "name": "highlightAlbum",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "coverImageUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HighlightManageFormDeleteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HighlightManageFormDeleteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "dc7cbb32f09e6b3db509c3ba488b8553",
    "id": null,
    "metadata": {},
    "name": "HighlightManageFormDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation HighlightManageFormDeleteMutation(\n  $input: NodeInput!\n) {\n  deleteHighlight(input: $input) {\n    id\n    highlightAlbum {\n      id\n      coverImageUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "97d6264bb8d1536d1df2f3026837eca9";

export default node;
